import React, { useState, useEffect } from "react";
import alinaAssets from "../../../assets/svg/AlinaIcons";
import { Link } from "react-router-dom";
import { HeaderData } from "./data";
import { StyledHeaderButton } from "../Button";
import { NavBar, NavBarItems } from "./styles";
import myThemes from "../../themes/Themes";
import { MenuItem, Menu, Hidden, Divider, ListItem } from "@mui/material";
import { faRightFromBracket } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "@mui/material";
import { logout } from "../../../api/authApi";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { removeUser } from "../../../redux/slices/userSlice";
import Spinner from "../Spinner";
import { Backdrop } from "@mui/material";
import { Chip } from "@mui/material";
import { faCaretDown, faBars } from "@fortawesome/free-solid-svg-icons";
import { useLocation } from "react-router-dom";
import { IconButton } from "@mui/material";
import { SwipeableDrawer } from "@mui/material";
import { List } from "@mui/material";
import { DrawerLink } from "./styles";

const Header = ({ theme }) => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const location = useLocation();
  const [currentPath, setCurrentPath] = useState("");
  const [openDrawer, setOpenDrawer] = useState(false);
  const open = Boolean(anchorEl);
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    console.log(currentPath);
    setCurrentPath(location.pathname);
  }, [location]);

  const handleLogout = async () => {
    setIsLoggingOut(true);
    await logout();
    localStorage.clear();
    dispatch(removeUser());
    setIsLoggingOut(false);
    navigate("/");
  };

  const handleOpenDrawer = () => {
    setOpenDrawer(true);
  };

  const handleCloseDrawer = () => {
    setOpenDrawer(false);
  };
  const getHeaderButtons = () => {
    if (user.roles.length === 0) return [];
    const data = HeaderData.map(({ label, href }) => {
      return (
        <StyledHeaderButton
          {...{
            key: label,
            to: href,
            label: label,
            component: Link,
          }}
          isFocused={currentPath.includes(href) ? true : false}
          theme={theme}
        >
          {label}
        </StyledHeaderButton>
      );
    });

    if (user.roles.includes("Operations")) {
      const operationsRoutes = [
        {
          label: "Settings",
          href: "/settings",
        },

        {
          label: "Dentists",
          href: "/dentists",
        },
      ];
      data.push(
        operationsRoutes.map((route) => (
          <StyledHeaderButton
            {...{
              key: route.href,
              to: route.href,
              label: route.label,
              component: Link,
            }}
            isFocused={currentPath.includes(route.href) ? true : false}
            theme={theme}
          >
            {route.label}
          </StyledHeaderButton>
        ))
      );
    }

    return data;
  };

  const getLinks = () => {
    if (user.roles.length === 0) return [];
    const data = HeaderData.map(({ label, href }) => {
      return (
        <>
          <ListItem>
            <DrawerLink
              underline="none"
              variant="button"
              {...{
                key: label,
                to: href,
                label: label,
                component: Link,
              }}
            >
              {label}
            </DrawerLink>
          </ListItem>
        </>
      );
    });

    if (user.roles.includes("Operations")) {
      const operationsRoutes = [
        {
          label: "Settings",
          href: "/settings",
        },

        {
          label: "Dentists",
          href: "/dentists",
        },
      ];
      data.push(
        operationsRoutes.map((route) => (
          <>
            <ListItem>
              <DrawerLink
                underline="none"
                variant="button"
                {...{
                  key: route.href,
                  to: route.href,
                  label: route.label,
                  component: Link,
                }}
              >
                {route.label}
              </DrawerLink>
            </ListItem>
          </>
        ))
      );
    }
    // data.push(
    //   <>

    //   </>
    // );
    return data;
  };

  return (
    <NavBar sx={{ pr: "20vh", pl: "20vh" }} theme={theme}>
      <NavBarItems disableGutters>
        <div style={{ marginRight: "auto" }}>
          {alinaAssets.logo(
            "100px",
            "60px",
            myThemes[theme].palette.quarternary
          )}
        </div>
        <Hidden mdDown style={{ position: "fixed" }}>
          {getHeaderButtons()}{" "}
          <div>
            {user.roles.length > 0 && (
              <span>
                <Tooltip title="Account settings">
                  <Chip
                    label={"Hello, " + user.firstname + "!"}
                    onClick={handleClick}
                    onDelete={handleClick}
                    deleteIcon={
                      <span style={{ color: "#0d0d0d", fontSize: "13px" }}>
                        <FontAwesomeIcon icon={faCaretDown} />
                      </span>
                    }
                    sx={{
                      height: "42px",
                      borderRadius: "50px",
                      marginLeft: "10px",
                      paddingRight: "5px",
                      color: "#0d0d0d",
                      fontSize: "14px",
                      fontFamily: "Inter",
                      fontWeight: "600",
                      backgroundColor: "#efefef",
                      "&: hover": {
                        filter: "brightness(80%)",
                        backgroundColor: "white",
                      },
                    }}
                  />
                </Tooltip>
                <Menu
                  anchorEl={anchorEl}
                  id="account-menu"
                  open={open}
                  onClose={handleClose}
                  onClick={handleClose}
                  PaperProps={{
                    elevation: 1,
                    sx: {
                      overflow: "visible",
                      filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                      mt: 1.5,
                      "& .MuiAvatar-root": {
                        width: 32,
                        height: 32,
                        ml: -0.5,
                        mr: 1,
                      },
                      "&:before": {
                        content: '""',
                        display: "block",
                        position: "absolute",
                        top: 0,
                        right: 14,
                        width: 10,
                        height: 10,
                        bgcolor: "background.paper",
                        transform: "translateY(-50%) rotate(45deg)",
                        zIndex: 0,
                      },
                    },
                  }}
                  transformOrigin={{ horizontal: "right", vertical: "top" }}
                  anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                >
                  <MenuItem onClick={() => handleLogout()}>Logout</MenuItem>
                </Menu>
              </span>
            )}
          </div>
        </Hidden>
        <Hidden mdUp>
          <IconButton onClick={handleOpenDrawer}>
            <FontAwesomeIcon color="white" icon={faBars} />
          </IconButton>
          <SwipeableDrawer
            PaperProps={{
              sx: { width: "40%" },
            }}
            open={openDrawer}
            anchor="right"
            onOpen={handleOpenDrawer}
            onClose={handleCloseDrawer}
          >
            <div
              style={{
                display: "inline",
                margin: "18px",
                padding: "16px",
                fontFamily: "Inter",
                fontSize: "16px",
                fontWeight: 700,
                cursor: "pointer",
                color: "white",
                backgroundColor: "#161616",
                borderRadius: "30px",
              }}
            >
              {"Hello, " + user.firstname + "!"}
            </div>
            <List
              style={{
                display: "inline",
                margin: "18px",
                fontSize: "16px",
                fontWeight: 700,
                cursor: "pointer",
                color: "white",
                backgroundColor: "#161616",
                borderRadius: "18px",
              }}
            >
              {getLinks()}
            </List>

            <List
              style={{
                display: "inline",
                margin: "18px",
              }}
            >
              <ListItem>
                <DrawerLink
                  onClick={() => handleLogout()}
                  underline="none"
                  variant="button"
                  style={{
                    cursor: "pointer",
                    color: "red",
                    fontWeight: 700,
                    textDecoration: "underline",
                  }}
                >
                  Logout
                </DrawerLink>
              </ListItem>
            </List>
          </SwipeableDrawer>
        </Hidden>
      </NavBarItems>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoggingOut}
      >
        <Spinner />
      </Backdrop>
    </NavBar>
  );
};

export default Header;
